var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owl-useage-patients-line-chart tw-font-sans tw-h-full"},[(!_vm.isLoading)?_c('line-chart',{attrs:{"id":_vm.chartId,"options":_vm.chartOptions}}):_c('owl-loading-indicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }